import React, {
  useEffect,
  useRef,
  useState
} from "react";

import {
  Content,
  Grid,
  GridItem,
  Stack,
  StackItem
} from "@patternfly/react-core";

import { SectionPanel } from "shared/components/SectionPanel";
import useAppearance from "shared/appearance/hooks/useAppearance";

import { partners } from "../data/partners";

import "../styles/PartnersPanel.css";

const PartnersPanel = ({
  isCard = false,
  showHeader = true,
  title = "Współpracujemy z",
  description =
    "Nasza szkoła współpracuje z firmami i instytucjami, które wspierają rozwój uczniów, praktyki zawodowe oraz edukację."
}) => {
    const { colorScheme } = useAppearance();
    const marqueeRef = useRef(null);
    const measureRef = useRef(null);

    const [repeatCount, setRepeatCount] = useState(2);

    useEffect(() => {
      const updateRepeatCount = () => {
        window.requestAnimationFrame(() => {
          const containerWidth =
            marqueeRef.current?.getBoundingClientRect().width ?? 0;

          const groupWidth =
            measureRef.current?.scrollWidth ?? 0;

          if (!containerWidth || !groupWidth) {
            return;
          }

          const count =
            Math.ceil(containerWidth / groupWidth) + 2;

          setRepeatCount(Math.max(2, count));
        });
      };

      updateRepeatCount();

      const observer = new ResizeObserver(updateRepeatCount);

      if (marqueeRef.current) {
        observer.observe(marqueeRef.current);
      }

      if (measureRef.current) {
        observer.observe(measureRef.current);
      }

      window.addEventListener("orientationchange", updateRepeatCount);

      return () => {
        observer.disconnect();
        window.removeEventListener(
          "orientationchange",
          updateRepeatCount
        );
      };
    }, []);

    const repeatedPartners = Array.from(
      { length: repeatCount },
      () => partners
    ).flat();
    
    const renderPartner = (
      partner,
      copy = false,
      index = 0
    ) => {
      const src =
        partner.src?.[colorScheme] ??
        partner.src?.light ??
        partner.src;
  
  return (
    <div
      className="partners-marquee__item"
      key={`${partner.id}-${copy ? "copy" : "original"}-${index}`}
    >
      <a
        href={partner.href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={copy ? undefined : partner.name}
        tabIndex={copy ? -1 : undefined}
        aria-hidden={copy ? "true" : undefined}
      >
        <img
          src={src}
          alt={copy ? "" : partner.name}
        //   loading="lazy"
          loading="eager"
          style={{
            height: `${partner.height}px`,
            width: "auto",
            display: "block"
          }}
        />
      </a>
    </div>
  );
};

  return (
    <SectionPanel isCard={isCard}>
      <Stack hasGutter>
        {showHeader && (title || description) && (
          <StackItem>
            <Grid>
              <GridItem
                span={10}
                offset={1}
                lg={8}
                lgOffset={2}
              >
                <Stack hasGutter>
                  {title && (
                    <StackItem>
                      <Content
                        component="h1"
                        style={{ textAlign: "center" }}
                      >
                        {title}
                      </Content>
                    </StackItem>
                  )}

                  {description && (
                    <>
                    <StackItem>
                      <Content
                        component="p"
                        style={{ textAlign: "center" }}
                      >
                        {description}
                      </Content>
                    </StackItem>
                    <StackItem isFilled />
                    </>
                  )}
                </Stack>
              </GridItem>
            </Grid>
          </StackItem>
        )}

        <StackItem>
        <div
            ref={marqueeRef}
            className="partners-marquee"
            aria-label="Partnerzy szkoły"
        >
            {/* Niewidoczny zestaw używany tylko do pomiaru szerokości */}
            <div
            ref={measureRef}
            className="partners-marquee__measure"
            aria-hidden="true"
            >
            {partners.map((partner, index) =>
                renderPartner(
                partner,
                true,
                index
                )
            )}
            </div>

            {/* Właściwa animowana taśma */}
            <div className="partners-marquee__track">
            <div className="partners-marquee__group">
                {repeatedPartners.map((partner, index) =>
                renderPartner(
                    partner,
                    index >= partners.length,
                    index
                )
                )}
            </div>

            <div
                className="partners-marquee__group"
                aria-hidden="true"
            >
                {repeatedPartners.map((partner, index) =>
                renderPartner(
                    partner,
                    true,
                    index + repeatedPartners.length
                )
                )}
            </div>
            </div>
        </div>
        </StackItem>
      </Stack>
    </SectionPanel>
  );
};

export default PartnersPanel;